const PIXEL_ID = '953724620390529'

export function initMetaPixel() {
  if (typeof window === 'undefined') return

  setTimeout(() => {
    try {
      if ((window as any).fbq) return

      const n: any = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments)
      }
      ;(window as any).fbq = n
      if (!(window as any)._fbq) (window as any)._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
      ;(window as any).fbq('init', PIXEL_ID)
      ;(window as any).fbq('track', 'PageView')
    } catch (e) {
      // Silent fail - pixel is non-critical
    }
  }, 500)
}

export function trackAddToCart() {
  try {
    if ((window as any).fbq) {
      ;(window as any).fbq('track', 'AddToCart', {
        currency: 'USD',
        value: 17,
        content_name: 'Plan de 21 Días de Vitalidad Menopáusica',
        content_type: 'product',
      })
    }
  } catch (e) {
    // Silent fail
  }
}
